import BaseModelAPI from '../BaseModelAPI';

export default class Subprocess extends BaseModelAPI {
	static entity = 'subprocess';
	static entityName = 'subprocess';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}